/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function AdvancedPdfSearch(props) {
  const { size, color, ...other } = props;
  return (
    <svg viewBox="0 0 24 24" fill="none" height={size} width={size} {...other}>
      <path
        d="M21 13C21 8.31371 21 10.6863 21 6C21 4.343 19.657 3 18 3H6C4.343 3 3 4.343 3 6V18C3 19.657 4.343 21 6 21H12"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 21C19.8807 21 21 19.8807 21 18.5C21 17.1193 19.8807 16 18.5 16C17.1193 16 16 17.1193 16 18.5C16 19.8807 17.1193 21 18.5 21Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 22L21 21"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.54099 14V9.27273H7.40605C7.7646 9.27273 8.07005 9.3412 8.32242 9.47816C8.57479 9.61358 8.76714 9.80208 8.89948 10.0437C9.03336 10.2837 9.1003 10.5607 9.1003 10.8746C9.1003 11.1886 9.03259 11.4656 8.89717 11.7056C8.76176 11.9457 8.56556 12.1326 8.30857 12.2665C8.05313 12.4004 7.74382 12.4673 7.38066 12.4673H6.19192V11.6664H7.21908C7.41144 11.6664 7.56994 11.6333 7.69458 11.5671C7.82076 11.4994 7.91463 11.4063 7.97619 11.2878C8.03928 11.1678 8.07082 11.0301 8.07082 10.8746C8.07082 10.7177 8.03928 10.5807 7.97619 10.4638C7.91463 10.3453 7.82076 10.2537 7.69458 10.1891C7.5684 10.1229 7.40836 10.0898 7.21447 10.0898H6.54046V14H5.54099ZM11.4253 14H9.74949V9.27273H11.4391C11.9146 9.27273 12.3239 9.36736 12.6671 9.55664C13.0103 9.74438 13.2742 10.0144 13.4588 10.3668C13.645 10.7192 13.7381 11.1409 13.7381 11.6317C13.7381 12.1242 13.645 12.5473 13.4588 12.9013C13.2742 13.2552 13.0087 13.5268 12.6625 13.7161C12.3178 13.9054 11.9054 14 11.4253 14ZM10.749 13.1436H11.3837C11.6792 13.1436 11.9277 13.0913 12.1293 12.9867C12.3324 12.8805 12.4848 12.7166 12.5863 12.495C12.6894 12.2719 12.741 11.9841 12.741 11.6317C12.741 11.2824 12.6894 10.997 12.5863 10.7754C12.4848 10.5538 12.3332 10.3907 12.1316 10.286C11.93 10.1814 11.6815 10.1291 11.386 10.1291H10.749V13.1436ZM14.4785 14V9.27273H17.6085V10.0968H15.478V11.2232H17.4007V12.0472H15.478V14H14.4785Z"
        fill={color}
      />
    </svg>
  );
}

AdvancedPdfSearch.defaultProps = {
  color: "currentColor",
  size: 24,
};

AdvancedPdfSearch.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
